import Repository from "@/repository";

export default {
  state: {
    notifications: [],
    interval: "",
    isResetInterval: false,
    isLoad: true,
  },
  actions: {
    async getNotifications({ commit }) {
      const { value, error } = await Repository.NotificationsActions.get()
      if (!error) {
        commit("setNotifications", value.data)
        commit("watchTime")
      }
    },
    async createNotification({ commit }, { message, project, time_to_notify }) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.NotificationsActions.create({ message, project, time_to_notify })
      if (!error) {
        commit("addNotificationToLead", value)
        commit("addNotification", value)
        commit("watchTime")
      }
      commit("setIsLoader", false);
    },
    async deleteNotification({ commit }, id) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.NotificationsActions.delete(id)
      if (!error) {
        commit("removeNotificationFromLead", id)
        commit("removeNotification", id)
        commit("watchTime")
      }
      commit("setIsLoader", false);
    },
    async readNotification({ commit }, id) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.NotificationsActions.read(id)
      commit("readNotification", id)
      commit("setIsLoader", false);
    }

  },
  mutations: {
    setNotifications(state, value) {
      state.notifications = value
    },
    addNotification(state, value) {
      state.notifications.unshift(value)
    },
    removeNotification(state, id) {
      state.notifications = state.notifications.filter(i => i.id !== id)
    },
    setIsNotificationLoad(state) {
      state.isLoad = false
    },
    readNotification(state, id) {
      const index = state.notifications.indexOf(state.notifications.find((i) => i.id === id))
      let notification = state.notifications[index]
      notification.is_read = true
      state.notifications.splice(index, 1, notification);
    },
    watchTime(state) {
      clearInterval(state.interval)
      let date = new Date().getTime();

      state.interval = setInterval(() => {
        let date = new Date().getTime();

        state.notifications.forEach(i => {
          let time = new Date(i.time_to_notify.slice(0, -4).split("T").join(" ")).getTime();

          if ((date - time) / 1000 / 60 <= 0.75 && (date - time) / 1000 / 60 >= 0) {
            const audio = new Audio(require('@/assets/sounds/new-order.wav'))
            audio.play()
            setTimeout(() => {
              alert("У вас новое уведомление: " + i.message)
            }, 1000);

          }
        })
      }, 30000)
    }
  }
};
